import { AxiosInstance } from 'axios';

interface requestSalesOrder {
    consumerInfo: {
        fullName?: string;
        phoneNumber: string;
        note?: string;
    };
    comment: string;
    tracking?: {
        source?: string;
        channel?: string;
        utm_term?: string;
        referral?: string;
        extraData?: string;
        utm_medium?: string;
        utm_source?: string;
        traffic_id?: string;
        utm_content?: string;
        utm_campaign?: string;
        url_referral?: string;
        internal_channel?: string;
    };
}

const serviceApi = (http: AxiosInstance) => {
    return {
        salesOrder: async (payload?: requestSalesOrder) => {
            const response = await http.post('/sales_order/create_lead', payload);
            return response.data;
        }
    };
};

export default serviceApi;